import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MainScreen from "./MainScreen";
import { useDispatch, useSelector } from "react-redux";
import { editListUsers } from "../utils/fetcher";
import AlertPaymentDetails from "./AlertPaymentDetails";
import { setPaymentDetails } from "../actions";
import { translator } from "../utils/i18n";
import { CURRENCY_SYMBOLS } from "../utils/constants";

export default function PaymentPopin() {
  const [open, setOpen] = React.useState(true);
  const paymentDetails = useSelector(state => state.paymentDetails);
  const usersSelected = useSelector(state => state.usersSelected);
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    dispatch(setPaymentDetails({ code: 0 }));
    dispatch(editListUsers(usersSelected));
    handleClose();
  };

  const getRecapContent = () => {
    const current = paymentDetails.info.date
      ? new Date(parseInt(paymentDetails.info.date) * 1000)
      : new Date();
    var date = current.toLocaleString(undefined, {
      day: "numeric",
      month: "long",
      year: "numeric"
    });

    date += " " + translator()._("W_AT") + " ";
    date +=
      current.toLocaleString(undefined, { hour: "2-digit" }) +
      " " +
      current.toLocaleString(undefined, { minute: "2-digit" });
    return (
      <div>
        <div
          style={{
            borderBottom: "1px solid rgb(42, 146, 138)",
            margin: "3% 0%",
            fontSize: "smaller"
          }}
        >
          {date}
        </div>
        <div className="recap-line">
          <b className="mr-20">{translator()._("W_NAME")}</b>
          <div>{paymentDetails.info.name}</div>
        </div>
        <div className="recap-line">
          <b className="mr-20">{translator()._("W_AMOUNT")}</b>
          <div>
            {paymentDetails.info.amount / 100 +
              "." +
              ("0" + (paymentDetails.info.amount % 100)).slice(-2) +
              CURRENCY_SYMBOLS[paymentDetails.info.currency]}
          </div>
        </div>
        <div className="recap-line">
          <b className="mr-20">{translator()._("W_TRANSACTION_NUMBER")}</b>
          <div>{paymentDetails.info.id}</div>
        </div>
      </div>
    );
  };

  const getRecap = () => {
    var content = getRecapContent();
    return (
      <AlertPaymentDetails
        title={paymentDetails.message}
        content={content}
        validate={true}
        handleValidate={handleSubmit}
      />
    );
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-payment"
        className="dialogPayment"
      >
        <DialogContent style={{ padding: 0 }}>
          <MainScreen />
        </DialogContent>
      </Dialog>
      {paymentDetails && paymentDetails.code === 1 && getRecap()}
    </div>
  );
  //TODO show recap in case
}
